var map = {
	"./af.json": 2473,
	"./am.json": 2474,
	"./ar.json": 2475,
	"./az.json": 2476,
	"./be.json": 2477,
	"./bg.json": 2478,
	"./bn.json": 2479,
	"./bs.json": 2480,
	"./ca.json": 2481,
	"./cs.json": 2482,
	"./cy.json": 2483,
	"./da.json": 2484,
	"./de.json": 2485,
	"./dv.json": 2486,
	"./el.json": 2487,
	"./en.json": 2488,
	"./es.json": 2489,
	"./et.json": 2490,
	"./eu.json": 2491,
	"./fa.json": 2492,
	"./fi.json": 2493,
	"./fr.json": 2494,
	"./gl.json": 2495,
	"./ha.json": 2496,
	"./he.json": 2497,
	"./hi.json": 2498,
	"./hr.json": 2499,
	"./hu.json": 2500,
	"./hy.json": 2501,
	"./id.json": 2502,
	"./is.json": 2503,
	"./it.json": 2504,
	"./ja.json": 2505,
	"./ka.json": 2506,
	"./kk.json": 2507,
	"./km.json": 2508,
	"./ko.json": 2509,
	"./ku.json": 2510,
	"./ky.json": 2511,
	"./lt.json": 2512,
	"./lv.json": 2513,
	"./mk.json": 2514,
	"./ml.json": 2515,
	"./mn.json": 2516,
	"./ms.json": 2517,
	"./nb.json": 2518,
	"./nl.json": 2519,
	"./nn.json": 2520,
	"./no.json": 2521,
	"./pl.json": 2522,
	"./ps.json": 2523,
	"./pt.json": 2524,
	"./ro.json": 2525,
	"./ru.json": 2526,
	"./sd.json": 2527,
	"./sk.json": 2528,
	"./sl.json": 2529,
	"./so.json": 2530,
	"./sq.json": 2531,
	"./sr.json": 2532,
	"./sv.json": 2533,
	"./sw.json": 2534,
	"./ta.json": 2535,
	"./tg.json": 2536,
	"./th.json": 2537,
	"./tr.json": 2538,
	"./tt.json": 2539,
	"./ug.json": 2540,
	"./uk.json": 2541,
	"./ur.json": 2542,
	"./uz.json": 2543,
	"./vi.json": 2544,
	"./zh.json": 2545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2472;